<template>
  <div
    class="delivery__map-modal--spots">
    <Input
      v-if="spotsInfo.length !== 1 && mailName !== 'pickup'"
      class="delivery__search-bar"
      @input="searchInput"
      :value="searchInputValue"
      input-class-name="delivery__search-bar"
      :placeholder="$t('search')"/>
    <div class="delivery__spots-wrapper custom-scrollbar" ref="deliverySpotsBlock">
      <DeliverySpot
        @selectSpot="selectSpot"
        v-for="(spot, i) in spots"
        :key="i"
        :spot="spot"
        :buy-on-store="buyOnStore"
        :without-add-to-cart="withoutAddToCart"
        :mailName="mailName"
        :product-id="productId"
      />
      <div class="observe-block" :class="{'observe-block--hidden': limit >= spotsInfo.length}" ref="observer"></div>
      <div class="warning-block" v-if="isProduct && !spots.length">{{ $t('map_product_warning') }}</div>
    </div>
  </div>
</template>

<script>
import DeliverySpot from './DeliverySpot'
import { mapState } from 'vuex'
import Input from '../../inputs/Input'
import { debounce } from '@/mixins'
export default {
  name: 'DeliverySpotsList',
  components: { Input, DeliverySpot },
  props: {
    withoutAddToCart: {
      type: Boolean,
      default: false
    },
    mailName: {
      type: String,
      required: true
    },
    spotsInfo: {
      type: Array,
      required: true
    },
    buyOnStore: {
      type: [Number, String]
    },
    productId: {
      type: [Number, String]
    }
  },
  mixins: [debounce],
  data () {
    return {
      searchInputValue: '',
      limit: 10,
      spots: [],
      filteredSpots: [],
      isSearching: false,
      unfilteredSpot: [],
      isProduct: this.$constants.IS_PRODUCT
    }
  },
  computed: {
    ...mapState({
      selectedSpot: state => state.map.selectedSpot
    })
  },
  methods: {
    searchInput (val) {
      this.searchInputValue = val

      if (val) {
        this.debounce(() => {
          this.filterSpots(val)
        }, 500)
        this.isSearching = true
      } else {
        this.limitSpots()
        this.isSearching = false
      }
    },
    limitSpots () {
      let spots = []
      const spotsSource = this.searchInputValue.length ? this.filteredSpots : this.unfilteredSpot

      if (this.limit > spotsSource.length) {
        this.spots = spotsSource
        return
      }

      for (let i = 0; i < this.limit; i++) {
        spots.push(spotsSource[i])
      }

      this.spots = spots
    },
    filterSpots (value) {
      if (!this.unfilteredSpot) return []

      const filteredArr = []
      for (let i = 0; i < this.unfilteredSpot.length; i++) {
        if (this.unfilteredSpot[i].description && this.unfilteredSpot[i].description.toLowerCase().includes(value.toLowerCase())) {
          filteredArr.push(this.unfilteredSpot[i])
        }
      }
      this.filteredSpots = filteredArr
      this.isSearching = false
      this.limit = 10
      this.limitSpots()
    },
    selectSpot (spot) {
      this.$emit('selectSpot', spot)
    },
    handleSearch (value) {
      this.searchInputValue = value
    }
  },
  watch: {
    limit () {
      this.limitSpots()
    },
    spotsInfo: {
      immediate: true,
      handler (value) {
        this.unfilteredSpot = value.slice()
        this.spots = this.unfilteredSpot
        let selectedIndex = null

        if (this.selectedSpot) {
          this.unfilteredSpot.forEach((spot, i) => {
            if (spot.description === this.selectedSpot.title) {
              selectedIndex = i
            }
          })
        }

        if (selectedIndex) {
          this.unfilteredSpot.unshift(...this.unfilteredSpot.splice(selectedIndex, 1))
        }

        this.limitSpots()
      }
    }
  },
  mounted () {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting && !this.isSearching) {
        this.limit = this.limit + 10
      }
    })
    observer.observe(this.$refs.observer)
  }
}
</script>

<style scoped lang="sass">

.delivery__map-modal--spots
  width: 30%
  border-top: 1px solid $nd-border-color

  +mmax(1100)
    width: 100%

    &-visible
      display: block

    &-hidden
      display: none

.delivery__search-bar
  display: block
  height: 40px
  font-size: 16px
  color: $placeholder-color
  width: 95%
  margin: 20px auto

.delivery__spots-wrapper
  overflow-y: auto
  height: 650px

  +mmaxh(800)
    height: calc(100vh - 225px)
  +mmax(1100)
    height: calc(100vh - 270px)

.observe-block
  height: 30px

  +mmin(1100)
    &--hidden
      height: 0

.warning-block
  margin: 20px
  padding: 20px
  border: 1px solid $main-color
  border-radius: 3px
</style>
